'use strict';

var _ = require('lodash');
var CHILDREN = 'children';
var REPEATER_TYPE = 'wysiwyg.viewer.components.Repeater';

function getAllCompsUnderRoot(model, rootId) {
  var compsUnderRoot = [rootId];
  for (var i = 0; i < compsUnderRoot.length; i++) {
    var children = _.get(model.components, [compsUnderRoot[i], CHILDREN]) || [];
    compsUnderRoot.push.apply(compsUnderRoot, children);
  }
  compsUnderRoot.shift();

  return compsUnderRoot;
}

function isTemplateComp(model, compId) {
  var getCompParent = function getCompParent(compId) {
    return _.get(model, ['components', compId, 'parent']);
  };
  var isCompRepeater = function isCompRepeater(compId) {
    return _.get(model, ['components', currentParent, 'type']) === REPEATER_TYPE;
  };
  var currentComp = compId;
  var currentParent = getCompParent(currentComp);
  // search for the parent that is also direct child of a repeater, if exist
  while (currentParent && !isCompRepeater(currentParent)) {
    currentComp = currentParent;
    currentParent = getCompParent(currentComp);
  }
  // if the direct child is in the repeater's children array, then its a template component, otherwise its a displayed only component
  return isCompRepeater(currentParent) && _.includes(_.get(model, ['components', currentParent, 'children']), currentComp);
}

module.exports = {
  getAllCompsUnderRoot: getAllCompsUnderRoot,
  isTemplateComp: isTemplateComp
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/modelUtils.js